import { API } from '@/src/api/api'
import type { User } from '@/src/types/user'

export const getUser = async (userFirebaseId: string): Promise<User | null> => {
  const users = await API.users.fetch({ firebaseId: userFirebaseId })
  return users?.[0] ? { ...users[0], isInvited: false } : null
}
